import { AtualizaSenha } from './../_models/atualiza-senha';
import { AlteraSenha } from './../_models/altera-senha';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from './base.service';
import { Login } from '../_models/login';
import { ItemMenuPai } from 'app/_models/menu/item-menu-pai';
import { ItemMenu } from 'app/_models/menu/item-menu';
import { AuthService } from './auth.service';
import { SncPrivacyNoticeService } from 'app/shared/custom/snc-privacy-notice/snc-privacy-notice.service';
import { DnSenacSeguranca } from 'app/_models/localstorage/dn-senac-seguranca';

@Injectable()
export class LoginService extends BaseService {

    headers: Headers;
    options: RequestOptions;
    private endPoint = '/login';

    constructor(private http: Http, private auth: AuthService,
        private sncAvisoPoliticaPrivacidade: SncPrivacyNoticeService)
    {
        super();
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: this.headers });
    }

    logar(login: Login): Observable<any> {
        const body = JSON.stringify({ usuario: login.usuario, senha: login.senha });

        return this.http
            .post(`${this.urlApi}${this.endPoint}`, body, this.options).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    solicitarNovaSenha(email: string): Observable<any> {
        const body = JSON.stringify({ email: email });

        return this.http
            .post(`${this.urlApi}${this.endPoint}/solicitacao-nova-senha`, body, this.options).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    atualizarSenha(atualizaSenha: AtualizaSenha): Observable<any> {
        return this.http
            .post(`${this.urlApi}${this.endPoint}/atualiza-senha`, atualizaSenha, this.options).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    alterarSenha(alteraSenha: AlteraSenha): Observable<any> {
        return this.http
            .post(this.urlApi + this.endPoint + '/editar-senha', alteraSenha, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    setarTokenLocalStorage(loginResponse: any) {
        this.sncAvisoPoliticaPrivacidade.recoveryPrivacyNoticeLocalStorage();
        localStorage.clear();
        this.sncAvisoPoliticaPrivacidade.savePrivacyNoticeLocalStorage();

        // TODO Remover código referente a versão (1) qdo ficar em definitivo a nova versão(2)
        if (this.api === '/api/v2') {
            var itemsMenu = loginResponse.data.usuario.menus.map(t => {
              return new ItemMenuPai({
                  nome: t.nome,
                  icone: t.icone,
                  link: '/' + t.link,
                  items: t.items.map(f => {
                      return new ItemMenu({
                          nome: f.nome,
                          link: '/' + f.link,
                          icone: f.icone
                      })
                  })
              });
          })
            var SenacSeguranca = new DnSenacSeguranca();
            SenacSeguranca.claims = loginResponse.data.usuario.claims;
            SenacSeguranca.seguranca = loginResponse.data.access_token;
            SenacSeguranca.nomeUsuario = loginResponse.data.usuario.nome;
            SenacSeguranca.menus = itemsMenu;
            SenacSeguranca.aceitePoliticaPrivacidade = 
                loginResponse.data.usuario.aceitePoliticaPrivacidade == undefined || loginResponse.data.usuario.aceitePoliticaPrivacidade == null ? false : loginResponse.data.usuario.aceitePoliticaPrivacidade;
            SenacSeguranca.aceitePoliticaPrivacidadeSIC = 
                loginResponse.data.usuario.aceitePoliticaPrivacidadeSIC == undefined || loginResponse.data.usuario.aceitePoliticaPrivacidadeSIC == null ? false : loginResponse.data.usuario.aceitePoliticaPrivacidadeSIC;
            SenacSeguranca.loginUsuario = loginResponse.data.usuario.login

            localStorage.setItem('dn-senac-seguranca', JSON.stringify(SenacSeguranca));
        } else {
            localStorage.setItem('seguranca', loginResponse.access_token);
            localStorage.setItem('nomeUsuario', loginResponse.usuario.nome);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/login.service.ts